export const ADMIN_SIGNIN_REQUEST = 'ADMIN_SIGNIN_REQUEST'
export const ADMIN_SIGNIN_SUCCESS = 'ADMIN_SIGNIN_SUCCESS'
export const ADMIN_SIGNIN_FAILED = 'ADMIN_SIGNIN_FAILED'
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT'